
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ProfileSettings from './ProfileSettings';
import NotificationSettings from './NotificationSettings';
import SecuritySettings from './SecuritySettings';
import ApiSettings from './ApiSettings';

const AccountSettings = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Account Settings</h2>
      
      <Tabs defaultValue="profile" className="w-full">
        <TabsList className="mb-4 w-full justify-start border-b pb-0 overflow-x-auto">
          <TabsTrigger value="profile" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Profile
          </TabsTrigger>
          <TabsTrigger value="notifications" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Notifications
          </TabsTrigger>
          <TabsTrigger value="security" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Security
          </TabsTrigger>
          <TabsTrigger value="api" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            API Settings
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="profile" className="py-4">
          <ProfileSettings />
        </TabsContent>
        
        <TabsContent value="notifications" className="py-4">
          <NotificationSettings />
        </TabsContent>
        
        <TabsContent value="security" className="py-4">
          <SecuritySettings />
        </TabsContent>
        
        <TabsContent value="api" className="py-4">
          <ApiSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AccountSettings;
